import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { R7_CHARTS_TOOLTIPS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DateRangeBannerService } from '../../services/date-range-banner.service';
import * as moment from 'moment';

@Component({
	selector: 'app-product-lift-chart-r7',
	templateUrl: './product-lift-chart-r7.component.html',
	styleUrls: ['./product-lift-chart-r7.component.css']
})
export class ProductLiftChartR7Component implements OnInit, WidgetCore, OnDestroy {
	public placeholderimage: string;
	public key: string;
	public timeserieskey: string;
	public sectionclass: string;
	@Input() colorsconfig: any;

	public campaignsList = [];
	public campaignCarouselItem: any;
	public showLoad = true;
	public hasData = false;
	public getDisplayIndex = 0;
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public widgetTimelineSubscription;
	public dateRangeSubscription;
	public showDateRangeBanner = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		private dateRangeBannerService: DateRangeBannerService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
		this.dateRangeSubscription = EmitterService.get(EVENT_EMITTERS.DATE_RANGE).subscribe((dateRange: any) => {
			this.showDateRangeBanner = this.dateRangeBannerService.checkDateRangeBanner(dateRange);
		});
	}

	ngOnInit() {
		this.requestData();
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.widgetTimelineSubscription) {
			this.widgetTimelineSubscription.unsubscribe();
		}
		if (this.dateRangeSubscription) {
			this.dateRangeSubscription.unsubscribe();
		}
	}

	requestData() {
		this.showLoad = true;
		this.hasData = false;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			if (res.success) {
				this.campaignsList = res.data;
				this.hasData = true;
				this.widgetTimelineSubscription = this.analyticsService
					.processWidgetRequest(this.timeserieskey)
					.subscribe((response: any) => {
						this.showLoad = false;
						if (response.success && response.data.length > 0) {
							this.campaignsList.map((campaignItem) => {
								campaignItem.data = response.data.filter((obj) => obj.campaign_id === campaignItem.campaign_id);
							});
						} else {
							this.hasData = false;
							this.campaignsList = [];
						}
						this.processResponseData();
						this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
						// Check banner when new data is received (for tab switching)
						this.showDateRangeBanner = this.dateRangeBannerService.shouldShowBannerForDateRange(
							this.analyticsDataModel.startDate,
							this.analyticsDataModel.endDate
						);
					});
			} else {
				this.showLoad = false;
				this.hasData = false;
			}
		});
	}

	processResponseData() {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				name: campaignItem.campaign_name,
				id: campaignItem.campaign_id,
				average_lift: campaignItem.average_lift,
				average_baseline: campaignItem.average_baseline,
				average_exposed_rate: campaignItem.average_conversion_rate,
				graphData: [],
				xAxis: {},
				yAxisPrimary: {},
				yAxisSecondary: {},
				legendLayout: {},
				title: {},
				subtitle: {},
				gridLineColor: '',
				height: '',
				width: '',
				tooltip: {},
				margin: [20, 60, 80, 50],
				spacing: [10, 10, 15, 10]
			};
			const baseline_data = [];
			const exposed_rate = [];
			const lift_data = [];
			const xAxisObj: any = {};
			const yAxisObjPrimary: any = {};
			const yAxisObjSecondary: any = {};
			const categories = [];
			const style = {
				fontSize: '12px',
				fontFamily: 'Rubik',
				color: '#213038'
			};
			campaignItem.data.forEach((dataObj) => {
				if (dataObj.average_baseline.match(/^</)) {
					baseline_data.push({
						y: Number(dataObj.average_baseline.substr(1)),
						str: '&lt;'
					});
				} else {
					baseline_data.push({
						y: Number(dataObj.average_baseline),
						str: ''
					});
				}

				// baseline_data.push(Number(dataObj.average_baseline));
				exposed_rate.push(Number(dataObj.average_conversion_rate));
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			xAxisObj.labels = { rotation: 0, style };
			yAxisObjPrimary.labels = {
				formatter: function () {
					return this.value + 'x Lift';
				},
				style
			};
			yAxisObjPrimary.labels.style.textOverflow = 'none';
			yAxisObjSecondary.labels = {
				formatter: function () {
					return parseFloat(this.value).toFixed(2) + '%';
				},
				style
			};
			xAxisObj.categories = categories;
			campaign.xAxis = xAxisObj;
			campaign.yAxisPrimary = yAxisObjPrimary;
			campaign.yAxisSecondary = yAxisObjSecondary;
			campaign.gridLineColor = '#ccc';
			(campaign.height = '200'),
				(campaign.width = '600'),
				(campaign.tooltip = Object.assign({}, R7_CHARTS_TOOLTIPS, {
					formatter: function () {
						let name = this.series.name.split(':')[0];
						let value = this.y;
						if (name == 'Exposed Rate' || name == 'Baseline Rate') {
							value = value + '%';
						} else if (name == 'Lift') {
							value = value + 'x';
						}
						return `<div class="tooltip">${name}</b><p><b>${value}</b></p><p>${moment(this.x).format(
							'MMM DD'
						)}</p></div>`;
					}
				}));
			campaign.graphData = [
				{
					showInLegend: true,
					type: 'column',
					prop: 'Lift',
					width: 400,
					name: 'Lift: ' + (Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)) + 'x ',
					pointWidth: 17,
					data: lift_data,
					zIndex: 0,
					color: this.getColorFromColorConfig(0, 1),
					fillColor: this.getColorFromColorConfig(0),
					yAxis: 1
				},
				{
					showInLegend: true,
					type: 'line',
					name: 'Exposed Rate: ' + parseFloat(campaign.average_exposed_rate).toFixed(2) + '% </b>',
					data: exposed_rate,
					zIndex: 1,
					color: this.getColorFromColorConfig(1, 1),
					fillColor: this.getColorFromColorConfig(1),
					marker: {
						enabled: exposed_rate.length <= 1
					}
				},
				{
					showInLegend: true,
					type: 'line',
					name:
						'Baseline Rate: ' +
						(UtilityService.isUndefinedOrNull(campaign.average_baseline)
							? '<0.01'
							: parseFloat(campaign.average_baseline).toFixed(2)) +
						'%',
					data: baseline_data,
					zIndex: 2,
					color: this.getColorFromColorConfig(2, 1),
					fillColor: this.getColorFromColorConfig(2),
					marker: {
						enabled: baseline_data.length <= 1
					}
				}
			];
			return campaign;
		});
		this.configGraphOptions();
	}

	protected buildLiftDataObject(dataObject: any) {
		const liftTempObj: any = {};
		if (Number(dataObject.average_lift) > 99) {
			liftTempObj.displayLift = '>99';
			liftTempObj.str = '&gt;';
			liftTempObj.y = 99;
		} else {
			liftTempObj.displayLift = dataObject.average_lift;
			liftTempObj.y = parseInt(dataObject.average_lift);
		}
		return liftTempObj;
	}

	public configGraphOptions() {
		this.campaignsList.forEach((campaign, index) => {
			campaign.legendLayout = {
				layout: 'horizontal',
				symbolHeight: 17,
				symbolWidth: 17,
				symbolRadius: 2,
				itemDistance: 50,
				margin: 20,
				//symbol : 'square',radius : 12,
				align: 'center',
				itemStyle: {
					fontSize: '12px'
				}
			};
			campaign.title = {
				text: null
			};
			// campaign.subtitle = {
			// 	useHTML: true,
			// 	align: 'center',
			// 	verticalAlign: 'bottom',
			// 	text: '<b>Lift: </b>' + (Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)) + 'x  ' +
			// 		' <b>Exposed Rate: </b>' + campaign.average_exposed_rate + '%    <b>Baseline Rate: </b>' + (UtilityService.isUndefinedOrNull(campaign.average_baseline) ? '<0.01' : (campaign.average_baseline)) + '%',
			// 	style: {
			// 		fontSize: '10px',
			// 		color: '#5B7D8D',
			// 	}
			// };
		});
	}

	prevArrow() {
		if (this.campaignsList.length > 1) {
			if (0 === this.getDisplayIndex) {
				this.getDisplayIndex = this.campaignsList.length - 1;
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
		}
	}

	nextArrow() {
		if (this.campaignsList.length > 1) {
			if (this.campaignsList.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
		}
	}

	protected getColorFromColorConfig(index: number, opacity?: number) {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
